import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Box,
  Button,
  Link as MuiLink,
} from "@mui/material"
import { Home, MessageCircle, TrendingUp, ArrowRight } from "lucide-react"
import { NavLink } from "react-router-dom"
import ArrowForwardIcon from "@mui/icons-material/ArrowForward"
const textColor = "#0d2561"
const itextColor = "#707070"
export default function MyPropertiesStatusWidget() {
  const data = {
    listedProperties: 15,
    totalActivities: 78,
    inquiries: 32,
    convertedToDeals: 8,
  }

  return (
    <Card>
     
      <CardContent>
        <Typography variant="h6" sx={{ color: textColor, mb: 1,fontSize:'1.20rem' }}>
          My Properties Status
        </Typography>
        <Typography variant="body2" sx={{ color: itextColor, mb: 2 }}>
          Number of properties listed by user, activities, inquiries, and conversions.
        </Typography>
        <Box mt={2} display="flex" flexDirection="column" gap={2}>
          <Box>
            <Box display="flex" alignItems="center" gap={2}>
              <Home style={{width:'20px',height:'20px'}}/>
              <Typography variant="h6" color="primary" sx={{ color: textColor,fontSize:'18px',fontWeight:'bold' }}>
                {data.listedProperties}
              </Typography>
            </Box>
            <Typography variant="body2" color="text.secondary" ml={5}>
              Properties Listed
            </Typography>
          </Box>

          <Box>
            <Box display="flex" alignItems="center" gap={2}>
              <MessageCircle style={{ color: "#3b82f6",fontWeight:600, width:'20px',height:'20px' }} />
              
              <Typography variant="h6" sx={{ color: "#3b82f6",fontSize:'18px',fontWeight:'bold' }}>
                {data.totalActivities}
              </Typography>
            </Box>
            <Typography variant="body2" color="text.secondary" ml={5}>
              Total Activities
            </Typography>
          </Box>

          <Box>
            <Box display="flex" alignItems="center" gap={2}>
              <MessageCircle style={{ color: "#f97316",fontWeight:600, width:'20px',height:'20px' }} />
              
              <Typography variant="h6" sx={{ color: "#f97316",fontSize:'18px',fontWeight:'bold' }}>
                {data.inquiries}
              </Typography>
            </Box>
            <Typography variant="body2" color="text.secondary" ml={5}>
              Inquiries
            </Typography>
          </Box>

          <Box>
            <Box display="flex" alignItems="center" gap={2}>
               <TrendingUp style={{ color: "#16a34a",fontWeight:600, width:'20px',height:'20px' }} />
             
              <Typography variant="h6" sx={{ color: "#16a34a",fontSize:'18px',fontWeight:'bold' }}>
                {data.convertedToDeals}
              </Typography>
            </Box>
            <Typography variant="body2" color="text.secondary" ml={5}>
              Converted to Deals
            </Typography>
          </Box>
        </Box>
        <Box textAlign="right" mt={1}>
          <NavLink to="#" style={{ textDecoration: "none" }}>
            <Button
              variant="text"
              size="small"
              endIcon={<ArrowForwardIcon />}
              sx={{
                textTransform: "none",
                fontSize: "0.875rem",
                p: 0,
                minHeight: "auto",
                color: textColor
              }}
            >
               View all Property statuses
            </Button>
          </NavLink>
        </Box>

        
      </CardContent>
    </Card>
  )
}
